import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Timeline, Stack, Button, Group, Divider } from "@mantine/core";
import { Cubby } from "../stores/Cubby";
import LedgerEntry from "./ledgerEntry";

const Ledger = observer(({ cubby }: { cubby: Cubby }) => {
  // State to manage the number of entries to show

  // Update localStorage whenever numToShow changes
  useEffect(() => {
    const storedValue = localStorage.getItem("numToShow");
    const valueToRight = storedValue ? parseInt(storedValue, 10) : 6;
    cubby.setNumTransactionsToShow(valueToRight);
  });

  // Fetch and sort ledger entries
  const ledgerEntries = cubby.ledgerEntries.sort(
    (a, b) => b.confirmedAtUnixtime - a.confirmedAtUnixtime
  );

  // Handler to update numToShow
  const handleSeeMore = () => {
    if (cubby.numTransactionsToShow === 6) cubby.setNumTransactionsToShow(20);
    else if (cubby.numTransactionsToShow === 20)
      cubby.setNumTransactionsToShow(200);
  };

  const handleSeeLess = () => {
    if (cubby.numTransactionsToShow === 200) cubby.setNumTransactionsToShow(20);
    else if (cubby.numTransactionsToShow === 20)
      cubby.setNumTransactionsToShow(6);
  };

  return (
    <>
      {ledgerEntries.length > 0 && (
        <Stack mt="lg" style={{ opacity: 1.0 }}>
          <Divider my="xs" />
          <Timeline active={-1} bulletSize={32} lineWidth={2}>
            {ledgerEntries.map((entry, index) => (
              <LedgerEntry key={index} entry={entry} cubby={cubby} />
            ))}
          </Timeline>

          {/* Show "See more" and "See less" buttons */}
          <Group justify="center" mt="md">
            {cubby.numTransactionsToShow > 6 && (
              <Button variant="subtle" size="xs" onClick={handleSeeLess}>
                See less
              </Button>
            )}
            {cubby.numTransactionsToShow < 200 && (
              <Button variant="subtle" size="xs" onClick={handleSeeMore}>
                See more
              </Button>
            )}
          </Group>
        </Stack>
      )}
    </>
  );
});

export default Ledger;
